import { SET_SELECTED_MENU } from "../types";

export const setSelectedMenu = (menuItem) => ({
    type: SET_SELECTED_MENU,
    payload: menuItem
});
